package com.vizio.redwolf.utils

actual val platform: Platform
    get() = Platform.JS